import { api } from '@/lib/api';
import type {
  BlogPost,
  BlogComment,
  BlogCategory,
  BlogRating,
  CreateBlogPostDto,
  UpdateBlogPostDto,
  CreateCommentDto,
  BlogFilters,
  PaginatedResponse,
} from '@/types/blog';

export const blogApi = {
  // Posts
  getPosts: (filters: BlogFilters = {}) =>
    api.get<PaginatedResponse<BlogPost>>('/blog/posts', { params: filters }).then((r) => r.data),

  getPost: (slug: string) =>
    api.get<BlogPost>(`/blog/posts/${slug}`).then((r) => r.data),

  createPost: (data: CreateBlogPostDto) =>
    api.post<BlogPost>('/blog/posts', data).then((r) => r.data),

  updatePost: (id: string, data: UpdateBlogPostDto) =>
    api.patch<BlogPost>(`/blog/posts/${id}`, data).then((r) => r.data),

  deletePost: (id: string) =>
    api.delete(`/blog/posts/${id}`).then((r) => r.data),

  getMyPosts: (filters: BlogFilters = {}) =>
    api.get<PaginatedResponse<BlogPost>>('/blog/posts/my', { params: filters }).then((r) => r.data),

  // Comments
  getComments: (postId: string) =>
    api.get<BlogComment[]>(`/blog/posts/${postId}/comments`).then((r) => r.data),

  createComment: (postId: string, data: CreateCommentDto) =>
    api.post<BlogComment>(`/blog/posts/${postId}/comments`, data).then((r) => r.data),

  deleteComment: (postId: string, commentId: string) =>
    api.delete(`/blog/posts/${postId}/comments/${commentId}`).then((r) => r.data),

  // Ratings
  ratePost: (postId: string, rating: number) =>
    api.post<BlogRating>(`/blog/posts/${postId}/rate`, { rating }).then((r) => r.data),

  getUserRating: (postId: string) =>
    api.get<BlogRating>(`/blog/posts/${postId}/rate`).then((r) => r.data),

  // Categories
  getCategories: () =>
    api.get<BlogCategory[]>('/blog/categories').then((r) => r.data),

  // Image upload
  uploadImage: (file: File) => {
    const formData = new FormData();
    formData.append('image', file);
    return api
      .post<{ url: string }>('/blog/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },
};
